import React from 'react';
import { DateInput, useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';
import './PeriodInputInstallationDate.css';

const PeriodInputInstallationDate = (props: { source: string; label: string }) => {
    const translate = useTranslate();

    return (
        <Box className='period-filter'>
            <DateInput
                size={'medium'}
                {...props}
                label={translate('app.common.after')}
                variant={'standard'}
                // source={`${props.source}[createdAt_after]`}
                // source={`${props.source}%5BcreatedAt_after%5D`}
                source={`${props.source}__after`}
            />

            <DateInput
                size={'medium'}
                {...props}
                variant={'standard'}
                label={translate('app.common.before')}
                // source={`${props.source}%5BcreatedAt_before%5D`}
                source={`${props.source}__before`}
            />
        </Box>
    );
};

export default PeriodInputInstallationDate;
